import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-8eNEiojQ.js';

const defaultTheme = stormLightTheme;

export { defaultTheme as d };
//# sourceMappingURL=index-BEYMdVG6.js.map
